import { create } from 'zustand';
import { ISchoolInvoiceForm } from '@modules/school-service/interfaces/school-invoice-form.interface';

interface FilterParams {
    currentPage: number;
    keyword: string;
}

interface InvoiceFormPageState {
    filterParams: FilterParams;
    setFilterParams: (params: Partial<FilterParams>) => void;

    // Popup
    isOpenPopup: boolean;
    editItem: Partial<ISchoolInvoiceForm> | undefined;
    openPopup: (item: Partial<ISchoolInvoiceForm>) => void;
    closePopup: () => void;
}

const useInvoiceFormPageStore = create<InvoiceFormPageState>((set) => ({
    filterParams: {
        currentPage: 1,
        keyword: '',
    },
    setFilterParams: (params) =>
        set((state) => ({
            filterParams: { ...state.filterParams, ...params },
        })),

    // Popup
    isOpenPopup: false,
    editItem: undefined,
    openPopup: (item) => set({ isOpenPopup: true, editItem: item }),
    closePopup: () => set({ isOpenPopup: false, editItem: undefined }),
}));

export default useInvoiceFormPageStore;
